import React from 'react';

import FinancesTable from './../components/FinancesTable';

const FinancesPage = () => {
    return (
        <div className="container mt20">
            <FinancesTable />
        </div>
    );
};

export default FinancesPage;


// WEBPACK FOOTER //
// ./src/pages/FinancesPage.js